/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { styled, SxProps, Theme, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { useLocation } from "react-router-dom";

import { CONTENT_LAYOUT_WIDTH, PAGE_PADDING_TOP } from "../../util/consts";
import { usePreviousPage } from "../../util/usePreviousPage";
import { MobileHeader } from "../MobileHeader";

export const PageElement = styled("div")(({ theme }) => ({
  width: "100%",
  maxWidth: "1280px",
  [theme.breakpoints.down("md")]: {
    paddingTop: `calc(${PAGE_PADDING_TOP.md + 48}px + var(--app-safe-area-top))`,
  },
  [theme.breakpoints.down("sm")]: {
    paddingTop: `calc(${PAGE_PADDING_TOP.md + 32}px + var(--app-safe-area-top))`,
  },
}));

interface Props {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

// Use me as the first container inside a routed page
export const PageContainer: React.FC<Props> = ({ children, ...props }: Props) => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.down("md"));
  const location = useLocation();
  const { setPreviousPage } = usePreviousPage();

  // Save the current page as the previous page when the component unmounts
  React.useEffect(() => {
    return () => {
      setPreviousPage(location.pathname);
    };
  }, []);

  return (
    <PageElement {...props}>
      <>
        {isMd && <MobileHeader />}
        {children}
      </>
    </PageElement>
  );
};

export const ListAndFiltersPageBodyContainer = styled("div")(({ theme }) => ({
  maxWidth: `${CONTENT_LAYOUT_WIDTH}px`,
  display: "flex",
  gap: "16px",
  [theme.breakpoints.down("lg")]: {
    flexDirection: "column",
  },
  [theme.breakpoints.between("sm", "md")]: {
    width: "100%",
  },
}));
